import gql from 'graphql-tag';

export default gql`
  fragment payjpCustomerFragment on PayjpCustomerType {
    id
    userId
    customerId
  }
`;
